// extracted by mini-css-extract-plugin
module.exports = {"section":"SeeInAction_section__r4YZY","heading":"SeeInAction_heading__FSpl_","deck":"SeeInAction_deck__A5vJP"};